/**
 * V2 API Response Envelope 解析
 * 成功：{ data } 或 { data, meta }；錯誤：{ error: { code, message } }
 */

/** 單筆成功：回傳 body.data，過渡期相容無 data 的舊格式 */
export function unwrapEnvelope<T>(body: unknown): T {
  if (body !== null && typeof body === 'object' && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
}

/**
 * 列表成功：將 V2 的 data + meta 轉成前端現有分頁格式 (list, page_on, page_size, total)
 * 供 usePaginatedList / PaginatedResponse 相容使用
 */
export interface UnwrappedListEnvelope<T> {
  list: T[];
  page_on: number;
  page_size: number;
  total: number;
}

export function unwrapListEnvelope<T>(body: unknown): UnwrappedListEnvelope<T> {
  if (body !== null && typeof body === 'object' && 'data' in body) {
    const data = (body as { data: T[] }).data;
    const list = Array.isArray(data) ? data : [];
    let page_on = 1;
    let page_size = list.length;
    let total = list.length;
    if ('meta' in (body as object) && (body as { meta?: unknown }).meta !== null) {
      const meta = (body as { meta?: { page?: number; pageSize?: number; total?: number } }).meta;
      if (meta && typeof meta === 'object') {
        page_on = meta.page ?? 1;
        page_size = meta.pageSize ?? list.length;
        total = meta.total ?? list.length;
      }
    }
    return { list, page_on, page_size, total };
  }
  const list = Array.isArray(body) ? (body as T[]) : [];
  return { list, page_on: 1, page_size: list.length, total: list.length };
}
